import styled from 'styled-components'

import { Link } from '@subaio/components'

import { helpers } from 'styles'

export const Container = styled(Link)`
	display: block;
	background: linear-gradient(150deg, ${helpers.color.cardBackgroundGradient}, ${helpers.color.cardBackground});
	border: 1px solid ${helpers.color.border};
	overflow-wrap: break-word;
	border-radius: 8px;
	padding: 32px;
	color: ${helpers.color.text};
	margin-bottom: 16px;
	transition: border-color 200ms ease;

	&:hover,
	&:active,
	&:focus {
		background: linear-gradient(150deg, ${helpers.color.cardBackgroundGradientHover}, ${helpers.color.cardBackground});
		border-color: ${helpers.color.primaryAccent};
		color: ${helpers.color.text};
		text-decoration: none;
	}
`
